<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="M 22.828125 1.949219 L 5.363281 1.949219 C 4.71875 1.949219 4.191406 2.472656 4.191406 3.121094 L 4.191406 8.097656 L 1.171875 8.097656 C 0.527344 8.097656 0 8.621094 0 9.269531 L 0 20.878906 C 0 21.527344 0.527344 22.050781 1.171875 22.050781 L 18.636719 22.050781 C 19.28125 22.050781 19.808594 21.527344 19.808594 20.878906 L 19.808594 15.902344 L 22.828125 15.902344 C 23.472656 15.902344 24 15.378906 24 14.730469 C 24 14.5 24 3.378906 24 3.121094 C 24 2.472656 23.472656 1.949219 22.828125 1.949219 Z M 18.402344 20.644531 L 1.40625 20.644531 L 1.40625 9.503906 L 18.402344 9.503906 Z M 22.59375 14.496094 L 19.808594 14.496094 L 19.808594 9.503906 L 22.59375 9.503906 Z M 22.59375 8.097656 C 22.402344 8.097656 6.347656 8.097656 5.597656 8.097656 L 5.597656 6.535156 L 22.59375 6.535156 Z M 22.59375 5.128906 L 5.597656 5.128906 L 5.597656 3.355469 L 22.59375 3.355469 Z M 22.59375 5.128906 "
        stroke-width="0.5"
        stroke="currentColor"
      />
      <path
        d="M 4 15.339844 L 6.070312 15.339844 C 6.601562 15.339844 7.050781 14.984375 7.195312 14.496094 C 7.257812 14.28125 7.242188 14.347656 7.242188 12.097656 C 7.242188 11.449219 6.714844 10.925781 6.070312 10.925781 L 4 10.925781 C 3.355469 10.925781 2.828125 11.449219 2.828125 12.097656 L 2.828125 14.167969 C 2.828125 14.8125 3.355469 15.339844 4 15.339844 Z M 4.234375 12.332031 L 5.835938 12.332031 L 5.835938 13.933594 L 4.234375 13.933594 Z M 4.234375 12.332031 "
        stroke-width="0.5"
        stroke="currentColor"
      />
      <path
        d="M 4.714844 17.175781 L 3.75 17.175781 C 3.359375 17.175781 3.046875 17.492188 3.046875 17.878906 C 3.046875 18.269531 3.359375 18.582031 3.75 18.582031 L 4.714844 18.582031 C 5.101562 18.582031 5.417969 18.269531 5.417969 17.878906 C 5.417969 17.492188 5.101562 17.175781 4.714844 17.175781 Z M 4.714844 17.175781 "
        stroke-width="0.5"
        stroke="currentColor"
      />
      <path
        d="M 6.828125 17.878906 C 6.828125 18.269531 7.140625 18.582031 7.53125 18.582031 L 8.496094 18.582031 C 8.882812 18.582031 9.199219 18.269531 9.199219 17.878906 C 9.199219 17.492188 8.882812 17.175781 8.496094 17.175781 L 7.53125 17.175781 C 7.140625 17.175781 6.828125 17.492188 6.828125 17.878906 Z M 6.828125 17.878906 "
        stroke-width="0.5"
        stroke="currentColor"
      />
      <path
        d="M 11.3125 18.582031 L 12.277344 18.582031 C 12.667969 18.582031 12.980469 18.269531 12.980469 17.878906 C 12.980469 17.492188 12.667969 17.175781 12.277344 17.175781 L 11.3125 17.175781 C 10.925781 17.175781 10.609375 17.492188 10.609375 17.878906 C 10.609375 18.269531 10.925781 18.582031 11.3125 18.582031 Z M 11.3125 18.582031 "
        stroke-width="0.5"
        stroke="currentColor"
      />
      <path
        d="M 15.09375 18.582031 L 16.058594 18.582031 C 16.449219 18.582031 16.761719 18.269531 16.761719 17.878906 C 16.761719 17.492188 16.449219 17.175781 16.058594 17.175781 L 15.09375 17.175781 C 14.707031 17.175781 14.390625 17.492188 14.390625 17.878906 C 14.390625 18.269531 14.707031 18.582031 15.09375 18.582031 Z M 15.09375 18.582031 "
        stroke-width="0.5"
        stroke="currentColor"
      />
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'PpkIcon',
  };
</script>
